/** @jsxImportSource @emotion/react */
import 'twin.macro';

import { Row, flexRender } from '@tanstack/react-table';
import { memo } from 'react';
import { DetailedUsage } from 'services/usage-tracking.service';
import {  formatSecondsToDuration } from 'utils/usageTracking.util';

interface IProps {
  itemRow: Row<DetailedUsage>;
  index: number;
  getApiKeyName: (apiName: string) => string;
}

export const UsageTrackingRow = memo<IProps>(({
  itemRow,
  getApiKeyName,
}) => {
  const usageItem = itemRow.original;
  const cells = itemRow.getVisibleCells();

  return (
    <tr
      key={itemRow.id}
      tw="hover:(bg-sonnant-grey-light) cursor-pointer"
      className="list-container"
    >
      {cells.map((cell) => {
        let displayValue: React.ReactNode;
        let titleValue: string;

        // Custom rendering for specific columns
        if (cell.column.id === 'apiName') {
          displayValue = getApiKeyName(usageItem.apiName);
          titleValue = String(displayValue || '');
        } else if (cell.column.id === 'contentType') {
          const cellValue = cell.getValue();
          const textValue = String(cellValue || '').toLowerCase();
          displayValue = (
            <span tw="capitalize">{textValue}</span>
          );
          titleValue = textValue;
        } else if (cell.column.id === 'durationSeconds') {
          const durationSeconds = usageItem.durationSeconds || 0;
          displayValue = formatSecondsToDuration(durationSeconds);
          titleValue = String(displayValue);
        } else if (cell.column.id === 'computeTimeSeconds') {
          const computeSeconds = usageItem.computeTimeSeconds || 0;
          displayValue = formatSecondsToDuration(computeSeconds);
          titleValue = String(displayValue);
        } else {
          displayValue = flexRender(cell.column.columnDef.cell, cell.getContext());
          // For other columns, try to get the raw cell value for the title
          titleValue = String(cell.getValue() || '');
        }

        // Get text align from column definition or default to center
        const columnStyle = (cell.column.columnDef as any)?.style;
        const textAlign = columnStyle?.textAlign || 'center';

        return (
          <td
            key={cell.id}
            style={{
              width: cell.column.getSize(),
              textAlign,
              maxWidth: cell.column.getSize(),
            }}
            tw="font-medium whitespace-nowrap overflow-hidden text-overflow[ellipsis]"
            title={titleValue}
          >
            {displayValue}
          </td>
        );
      })}
    </tr>
  );
});

